/** Customer copy for Twitch live detection setup in the onboarding wizard. */

export const TWITCH_SETUP_INTRO_COPY =
  'Live detection runs automatically once members connect Twitch and alerts are ready. Partial coverage shows as a warning; zero eligible broadcasters blocks automation until resolved.';

export const TWITCH_OWNER_REPAIR_COPY =
  'Twitch alert repair is managed by the league owner. Ask the owner to run repair if alerts look stuck or failed.';

export const TWITCH_ZERO_BROADCASTERS_COPY =
  'No eligible broadcasters are ready yet. Add members and link Twitch accounts before live detection or automation can start.';

export const TWITCH_PARTIAL_COVERAGE_COPY =
  'Some members still need Twitch mapping or alert setup. Live detection may miss games until coverage improves.';
